/**
 * SISTEMA DECLARATIVO MODULAR - PUNTO DE ENTRADA PRINCIPAL
 * Ahora incluye el sistema de auto-registro de componentes
 */

// Configuraciones
import { siteConfig, headerConfig, footerConfig } from "./config/global.js";
import { brandingConfig } from "./config/branding.js";
import { responsiveConfig } from "./config/responsive.js";
import {
  gamesShowcaseConfig,
  getGamesShowcaseConfig,
} from "./config/swiper.js";

// Datos
import { experiences } from "./data/experiences.js";
import { sections } from "./data/sections.js";
import { pages } from "./data/pages.js";

// 🆕 Sistema de componentes auto-registrantes
import {
  COMPONENTS,
  getComponent,
  getAvailableComponents,
  isComponentRegistered,
} from "./components.js";

// API y utilidades (mantenemos solo las esenciales)
import contentAPI, {
  getExperience,
  getSection,
  getPage,
  getAllExperiences,
  getExperiencesByCategory,
  getFeaturedExperiences,
  resolvePageSections,
  generateSEOMetadata,
  getResponsiveConfig,
  getPopularExperiences,
  getNewExperiences,
  getExperiencesByDifficulty,
  validateAllContent,
  enableDebugMode,
  debugLog,
} from "./utils/api.js";

// Esquemas (simplificados)
import { SECTION_TYPES, BUTTON_VARIANTS, ANIMATIONS } from "./schemas/types.js";
import {
  sectionSchema,
  pageSchema,
  experienceSchema,
  validateObject,
  validateSection,
  validatePage,
  validateExperience,
} from "./schemas/validation.js";

// Configuración global unificada
export const globalConfig = {
  site: siteConfig,
  header: headerConfig,
  footer: footerConfig,
  branding: brandingConfig,
  responsive: responsiveConfig,
  swiper: {
    gamesShowcase: gamesShowcaseConfig,
    getGamesShowcaseConfig,
  },
};

// Exportaciones de configuración
export {
  siteConfig,
  headerConfig,
  footerConfig,
  brandingConfig,
  responsiveConfig,
  gamesShowcaseConfig,
  getGamesShowcaseConfig,
};

// Exportaciones de datos
export { experiences, sections, pages };

// 🆕 Exportaciones del sistema de componentes
export {
  COMPONENTS,
  getComponent,
  getAvailableComponents,
  isComponentRegistered,
};

// API esencial
export {
  contentAPI,
  getExperience,
  getSection,
  getPage,
  getAllExperiences,
  getExperiencesByCategory,
  getFeaturedExperiences,
  resolvePageSections,
  generateSEOMetadata,
  getResponsiveConfig,
  getPopularExperiences,
  getNewExperiences,
  getExperiencesByDifficulty,
  validateAllContent,
  enableDebugMode,
  debugLog,
};

// Esquemas y validación
export {
  SECTION_TYPES,
  BUTTON_VARIANTS,
  ANIMATIONS,
  sectionSchema,
  pageSchema,
  experienceSchema,
  validateObject,
  validateSection,
  validatePage,
  validateExperience,
};

export default contentAPI;

// Debug para desarrollo
if (
  typeof window !== "undefined" &&
  import.meta.env.NODE_ENV === "development"
) {
  enableDebugMode();
  contentAPI
    .initialize()
    .then(() => {
      console.log("🎯 Sistema de contenido inicializado");
      console.log("📦 Componentes disponibles:", getAvailableComponents());
    })
    .catch(console.error);
}
